import { SubjectTypeProps } from "@custom-types/base-types";
import { FaroCoreApiTypes } from "@stellar/core-api-client";
import { BaseProduct, ProductType } from "@utils/product/product-utils-types";
import {
  isCreditProductIdentifier,
  isEnterpriseProductIdentifier,
} from "@utils/type-guards";

interface AvailableLimitsForSubjectTypeProps extends SubjectTypeProps {
  /** The selected product */
  selectedProduct: BaseProduct<ProductType>;
}

/** Returns all limits that are available for a specific product and subject type. */
export function availableLimitsForSubjectType({
  selectedProduct,
  subjectType,
}: AvailableLimitsForSubjectTypeProps): FaroCoreApiTypes.LimitType[] {
  // Check if the product is credits, then return only the credits limit
  if (isCreditProductIdentifier(selectedProduct.identifier)) {
    return ["CREDITS"];
  }

  if (isEnterpriseProductIdentifier(selectedProduct.identifier)) {
    // Storage comes from the tier selection, active users can be added on top of it
    return ["STORAGE", "USER_ROLE"];
  }

  // Plans with mandatory defaults expose exactly the limit types they define
  const { limits } = selectedProduct.scope[subjectType];
  if (limits.type === "required-with-defaults") {
    return limits.defaults.map((limit) => limit.type);
  }

  switch (subjectType) {
    case "PROJECT":
      return ["WAYPOINT", "TIMETRAVEL_ON_WAYPOINT"];

    case "COMPANY":
    case "DEVICE":
      return ["PROJECT_AREA", "PROJECT_COUNT", "STORAGE", "USER_ROLE"];

    case "USER":
      throw new Error(
        `availableLimitsForSubjectType(): Creating plans with subject ${subjectType} is not supported`
      );

    default:
      throw new Error("Subject not defined; creating plans is unsupported.");
  }
}
